import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { i18nLanguage } from "./i18nLanguage.model";
import { PointOfService } from "./PointOfService.model";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { TruckerActivity } from "./TruckerActivity.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { RegexType } from "../../services/RegexPatternLibrary";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Trucker' // optionnel car par defaut utilise le nom de classe
})
export class Trucker extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  // Alphanumeric et non « Alphabetic|Numeric » : la combinaison produit une alternative
  // (soit tout alphabetique, soit tout numerique) et refuse donc les valeurs mixtes.
  @Validation({ maxLength: 255, propertyType: RegexType.Alphanumeric })
  firstName!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({ maxLength: 255, propertyType: RegexType.Alphabetic ,minLength:2,  })
  lastName!: string;


  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  fullName!: string;

  @Validation({ minLength:6 ,maxLength: 255, propertyType: RegexType.Email })
  email?: string;

  @Validation({ maxLength: 50, minLength: 6 , propertyType: RegexType.NorthAmericanPhone })
  phoneNumber?: string;

  address?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({ maxLength: 255, minLength:2, propertyType: `${RegexType.Alphabetic}|${RegexType.WithSpecialChars}` })
  companyName!: string;

  comment?: string;

  fK_Language?: number;

  emailNotification?: boolean;

  smsNotification?: boolean;

  fK_Attachments?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_POS!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn] })
  status!: number;

  @Validation({ maxLength: 100, propertyType: `${RegexType.Alphabetic}` })
  licence?: string;

  fK_Image_Agreements?: number;

  validated?: number;

  validatedBy?: string;

  validatedOn?: Date;

  @NestedProperty({ TargetType: i18nLanguage })
  language?: i18nLanguage;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageAgreements?: FSTREAM_Image;

  @NavigationProperty({ TargetType: TruckerActivity })
  truckerActivities?: TruckerActivity[];

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  GetType(): IEntityMetaData {
    return Trucker.getMetaData();
  }
}
